import React, { useState } from 'react';
import { Link } from 'react-router-dom';

function Login() {
  const [formData, setFormData] = useState({
    username: '',
    password: '',
    rememberMe: false
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle login logic here
    console.log('Login attempt:', formData);
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  return (
    <>
      <section className="inner-intro bg-1 bg-overlay-black-70">
        <div className="container">
          <div className="row text-center intro-title">
            <div className="col-md-12 text-md-start d-inline-block">
              <div className="section-title">
                <h2 className="text-center" style={{color: 'white'}}>Login to Your Account</h2>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="login-form page-section-ptb">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="section-title">
                <span>Log in with your id</span>
                <h2>Login To Your Account</h2>
                <div className="separator"></div>
              </div>
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="col-lg-6 col-md-12">
              <div className="gray-form clearfix">
                <form onSubmit={handleSubmit}>
                  <div className="mb-3">
                    <label className="form-label" htmlFor="name">User name*</label>
                    <input 
                      id="name" 
                      className="form-control" 
                      type="text" 
                      placeholder="User name" 
                      name="username"
                      value={formData.username}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label" htmlFor="Password">Password*</label>
                    <input 
                      id="Password" 
                      className="form-control" 
                      type="password" 
                      placeholder="Password" 
                      name="password"
                      value={formData.password}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <div className="remember-checkbox mb-4">
                      <input 
                        type="checkbox" 
                        name="rememberMe" 
                        id="one"
                        checked={formData.rememberMe}
                        onChange={handleInputChange}
                      />
                      <label htmlFor="one">Remember me</label>
                      {/* <Link to="/forgot-password" className="float-end">Forgot Password?</Link> */}
                    </div>
                  </div>
                  <div className="d-grid">
                    <button type="submit" className="button red btn-block">Log in</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Login;
